import {
    useMemo,
} from 'react'
import StatusHandler from 'app/shared-components/StatusHandler'
import GatewayRequests from 'app/requests/Gateway.requests'
import {
    OperatingHours, OperationalDays,
} from 'app/enums/label.enums'
import useGetGateway from '../hooks/useGetGateway'
import {
    WorkSchedule as TWorkSchedule,
} from '../Gateways.types'
import WorkScheduleForm from './WorkScheduleForm'

export default function WorkSchedule({
    id,
}: Readonly<{ id: number }>) {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        invalidate,
        error,
    } = useGetGateway(id)

    const formData = useMemo(() => {
        if (!isDataReady) {
            return undefined
        }
        return {
            operatingHours: data?.gatewayWorkSchedule?.operatingHours || OperatingHours.ALL_DAY,
            operatingDays: data?.gatewayWorkSchedule?.operatingDays
                || OperationalDays.MONDAY_SUNDAY,
            workEndsAt: data?.gatewayWorkSchedule?.workEndsAt,
            workStartsAt: data?.gatewayWorkSchedule?.workStartsAt,
        } as TWorkSchedule
    }, [
        data,
        isDataReady,
    ])

    return (
        <StatusHandler
            isSuccess={isDataReady}
            isFetching={isFetching}
            isError={isError}
            error={error}
        >
            <WorkScheduleForm
                requestParam={GatewayRequests.workSchedule({
                    id,
                })}
                data={formData}
                onSuccess={invalidate}
                onCancel={invalidate}
            />
        </StatusHandler>
    )
}
